import { AUDIENCE_STATUS, AUDIENCE_TYPE } from 'modules/audiences/config';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const shouldShowTooltip = data => {
    const { status, type } = data;
    return type === AUDIENCE_TYPE.PBP_LOOKALIKE && status === AUDIENCE_STATUS.REJECTED;
};

export const CustomAudiencesRejectedStatusTooltip = () => {
    return (
        <div>
            <FormattedMessage
                id="report.audienceStatus.reject.pixelPredictive.tooltip"
                defaultMessage="This audience wasn't created because the model didn't detect strong, consistent conversion patterns or meet accuracy thresholds. The model retrains daily, so the audience may become active later. To improve chances, try running a broad targeting campaign to collect more conversion signals."
            />
        </div>
    );
};
